import { useEffect } from 'react';
import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { useRouter } from '@medifind/router';
import { sessionStorageMF } from '../utils';

const invalidUTMSources = ['doctor-finder'];

export const useAdSuppress = () => {
  const router = useRouter();

  useEffect(() => {
    const { utm_source } = router.query;
    if (utm_source) {
      useAdSuppressStore.setState({ adSuppress: invalidUTMSources.includes(utm_source) }, true);
    }
  }, []);

  return useAdSuppressStore();
};

const storeName = 'ad-suppress';
const useAdSuppressStore = create(
  devtools(
    persist((set) => ({ set }), {
      name: `${process.env.NX_APP}-${storeName}`,
      version: 0,
      storage: createJSONStorage(() => sessionStorageMF),
    }),
    {
      name: `${process.env.NX_APP}`,
      store: storeName,
    },
  ),
);
